//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";
import access from "config/access";

// custom pages
import { styles } from "./styles";
import promotion from "apis/promotion/promotion";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";
import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

const typeArr = [
  {
    label: "Order Line Number",
    value: "order_line_number",
  },
  {
    label: "Order ID",
    value: "order_id",
  },
  {
    label: "Loyalty Id",
    value: "loyalty_id",
  },
];

const frequencyArr = [
  {
    label: "Monthly",
    value: "MONTHLY",
  },
  {
    label: "Daily",
    value: "DAILY",
  },
];
 const tierArr = [
  // { label: "CORE", value: "Core" },
  // { label: "SELECT", value: "Select" },
  { label: "ELITE", value: "Elite" },
];

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { createRule } = promotion();
  const history = useHistory();
  const classes = styles();
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({
    promotionId: "",
    promotionName: "",
    promotionDescription: "",
    startDate: null,
    endDate: null,
    extendedDays: 0,
    // ranking: null,
    type: "",
    frequency: "",
    isActive: true,
    isSignature: false,
    isUnlock: false,
    loading: false,
    expireDate: null,
    isLimited:false,
    limit:1,
    limitType:"customer_account_number",
     priority: null,
     tierRatioApplicable:false,
     isAdjustmentPromo:false,
     isStartup:false,
     isStartupAutoRedeem:false,
     isTierPromo:false,
     tier:null,

  });

  const {
    promotionId,
    promotionName,
    promotionDescription,
    startDate,
    endDate,
    extendedDays,
    // ranking,
    type,
    frequency,
    isActive,
    isSignature,
    isUnlock,
    loading,
    expireDate,
    isLimited,
    limit,
    limitType,
    priority,
    tierRatioApplicable,
    isAdjustmentPromo,
    isStartup,
    isStartupAutoRedeem,
    isTierPromo,
    tier,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Create"],
    });
  }, []);

  const blockInvalidChar = (e) =>{
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
  }
  // create api func
  const handleCreateRule = async () => {
    try {
      if (
       
        !promotionName ||
        !promotionDescription ||
        !startDate ||
        !endDate ||
        !expireDate ||
        !type ||
        !frequency 
       
      ) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      if(startDate=="Invalid Date"||endDate=="Invalid Date"||expireDate=="Invalid Date"){
        toast.error("Invalid Date Format");
        setStates({ loading: false });
        return;
      }
      if(isLimited && ((limit=="" || !limit)||(limit&&limit<1))){
        toast.error("Please enter the Limit");
        setStates({ loading: false });
        return;
      }
    
      let values;
      values = {
        promotionId,
        promotionName,
        promotionDescription,
        startDate: moment(startDate).format("MM/DD/YYYY"),
        endDate: moment(endDate).format("MM/DD/YYYY"),
        expireDate: moment(expireDate).format("MM/DD/YYYY"),
        extendedDays: parseInt(extendedDays),
        // ranking: parseInt(ranking),
        type,
        frequency,
        isActive,
        isSignature:(isStartup || isUnlock )?false:isSignature,
        isUnlock:(isStartup || isSignature)?false:isUnlock,
        isAdjustmentPromo:(isStartup || isUnlock )?false:isAdjustmentPromo,
        isLimited,
        limit:isLimited?limit:null,
        limitType:isLimited?limitType:null,
        priority,
        tierRatioApplicable:(isSignature || isStartup || isUnlock)?false:tierRatioApplicable,
        isStartup:(isSignature || isUnlock)?false:isStartup,
        isTierPromo:(isSignature || isStartup  || isUnlock) ? false : isTierPromo,
        tier,
        isStartupAutoRedeem:(isSignature || isUnlock)?false:isStartup?isStartupAutoRedeem:false,
      };
       let res = await createRule(values);
      if (res && res?.type === "SUCCESS") {
        toast.success("Created", { toastId: "rule-created" });
        history.goBack();
      }
      if (res && res?.type === "ERROR") {
        toast.error("Promotion Already Exists", {
          toastId: "promotion-exists",
        });
      }
      setStates({ loading: false });
    } catch (e) {
      console.log({ e });
    }
  };

  const locale = i18n.language == 'fr' ? fr : enUS;

  

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>{t('Create')}</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        {/* <Grid item xs={3}>
          <CssTextField
            label={t("Promotion Id")}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={promotionId}
            onChange={(e) => {
              setStates({ promotionId: e.target.value });
            }}
          />
                </Grid> */}
                <Grid item xs={3}>
          <CssTextField
            label={t("Promotion Name")}
            fullWidth
            type="text"
            onKeyDown={blockInvalidCharForText}
            onInput={(e) => {
              const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, ""); 
              if (value !== e.target.value) {
                e.target.value = value; 
              }
              setStates({ promotionName: value });
            }}
            required
            className={classes.cssTextField}
            value={promotionName}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 50) {
                setStates({ promotionName: value });
                
              }
            }}
            error={promotionName.length === 50} // Show error when character limit is reached
            helperText={promotionName.length === 50 ? "Promotion Name cannot exceed 50 characters" : ""}
            inputProps={{ maxLength: 50 }} // Limit input length to 50 characters
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            label={t("Promotion Description")}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={promotionDescription}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 50) {
                setStates({ promotionDescription: value });
              }
            }}
            error={promotionDescription.length === 50} // Show error when character limit is reached
            helperText={promotionDescription.length === 50 ? "Promotion Description cannot exceed 50 characters" : ""}
            inputProps={{ maxLength: 50 }} 
             
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Type"}
            label={t("Type")}
            select
            fullWidth
            type={"text"}
            required
            value={type}
            onChange={(e) => {
              setStates({ type: e.target.value });
            }}
          >
            {typeArr.map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>        
        <Grid item xs={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
              label={t("Start Date")}
              id="date-picker-inline"
              className={classes.dateInput}
              required
              value={startDate}
              onChange={(date) => {
                if (
                  moment(moment(date).format("MM/DD/YYYY")).isAfter(
                    moment(endDate).format("MM/DD/YYYY")
                  )
                ) {
                  toast.error("Start date should be lesser than End date.", {
                    toastId: "start-date-error",
                  });
                  setStates({ startDate: null });
                  return;
                }
                setStates({ startDate: date });
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              autoOk
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
              label={t("End Date")}
              id="date-picker-inline"
              className={classes.dateInput}
              required
              value={endDate}
              onChange={(date) => {
                if (
                  moment(moment(date).format("MM/DD/YYYY")).isBefore(
                    moment(startDate).format("MM/DD/YYYY")
                  )
                ) {
                  toast.error("End date should be greater than start date.", {
                    toastId: "end-date-error",
                  });
                  setStates({ endDate: null });
                  return;
                }
                if (
                  moment(moment(date).format("MM/DD/YYYY")).isAfter(
                    moment(expireDate).format("MM/DD/YYYY")
                  )
                ) {
                  toast.error("End date should be lesser than extended date.", {
                    toastId: "end-date-error",
                  });
                  setStates({ endDate: null });
                  return;
                }
                setStates({ endDate: date });
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              autoOk
            />
          </MuiPickersUtilsProvider>
        </Grid>
        {/* <Grid item xs={3}>
          <CssTextField
            label={t("Extended Days")}
            fullWidth
            type={"number"}
            onKeyDown={blockInvalidChar}
            className={classes.cssTextField}
            required
            value={extendedDays}
            onChange={(e) => {
              setStates({ extendedDays: e.target.value });
            }}
          />
        </Grid> */}
        <Grid item xs={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              label="Extended Date"
              id="date-picker-inline"
              className={classes.dateInput}
              required
              value={expireDate}
              onChange={(date) => {
                if (
                  moment(moment(date).format("MM/DD/YYYY")).isBefore(
                    moment(endDate).format("MM/DD/YYYY")
                  )
                ) {
                  toast.error("Extended date should be greater than end date.", {
                    toastId: "end-date-error",
                  });
                  setStates({ expireDate: null });
                  return;
                }
                setStates({ expireDate: date });
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              autoOk
            />
          </MuiPickersUtilsProvider>
        </Grid>
        {/* <Grid item xs={3}>
          <CssTextField
            label={t("Ranking")}
            fullWidth
            type={"number"}
            onKeyDown={blockInvalidChar}
            className={classes.cssTextField}
            required
            value={ranking}
            onChange={(e) => {
              setStates({ ranking: e.target.value });
            }}
          />
        </Grid> */}
        <Grid item xs={3}>
          <CssTextField
            id={"Frequency"}
            label={t("Frequency")}
            select
            fullWidth
            type={"text"}
            required
            value={frequency}
            onChange={(e) => {
              setStates({ frequency: e.target.value });
            }}
          >
            {frequencyArr.map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Is Active"}
            label={t("Status")}
            select
            fullWidth
            type={"text"}
            required
            value={isActive}
            onChange={(e) => {
              setStates({ isActive: e.target.value });
            }}
          >
            {[
              { label: "Active", value: true },
              { label: "Inactive", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup && !isUnlock)&& <Grid item xs={3}>
          <CssTextField
            id={"Is Signature"}
            label={t("Is Signature")}
            select
            fullWidth
            type={"text"}
            required
            value={isSignature}
            disabled={isTierPromo === true}
            onChange={(e) => {
            setStates({
            isSignature: e.target.value      // Disable Startup if Signature is enabled
          })
          }}

          >
            
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}

        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup  && !isUnlock && !isSignature)&& <Grid item xs={3}>
          <CssTextField
            id={"Is AdjustmentPromo"}
            label={t("Is AdjustmentPromo")}
            select
            fullWidth
            type={"text"}
            required
            value={isAdjustmentPromo}
            disabled={isTierPromo === true}
            onChange={(e) => {
              const value=e.target.value
              setStates({ 
                isAdjustmentPromo: value,
                });
            }}
          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}


        {state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' &&  <Grid item xs={3}>
          <CssTextField
            id={"Is Limit"}
            label={t("Is Limited")}
            select
            fullWidth
            type={"text"}
            required
            value={isLimited}
            disabled={isAdjustmentPromo === true}
            onChange={(e) => {
              setStates({ isLimited: e.target.value });
            }}
            
          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}

        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isSignature &&!isUnlock )&& <Grid item xs={3}>
          <CssTextField
            id={"Is Startup"}
            label={t("Is Startup")}
            select
            fullWidth
            type={"text"}
            required
            value={isStartup}
            disabled={isTierPromo === true}
            onChange={(e) => {
            setStates({
            isStartup: e.target.value,
          });
          }}

          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && isStartup )&& <Grid item xs={3}>
          <CssTextField
            id={"Is Startup Auto Redeem"}
            label={t("Is Startup Auto Redeem")}
            select
            fullWidth
            type={"text"}
            required
            value={isStartupAutoRedeem}
            disabled={isTierPromo === true}
            onChange={(e) => {
            setStates({
              isStartupAutoRedeem: e.target.value,
          });
          }}

          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isSignature && !isUnlock && !isStartup) && <Grid item xs={3}>
          <CssTextField
              id={"Is Tier Promo"}
              label={t("Is Tier Promo")}
              select
              fullWidth
              type={"text"}
              required
              value={isTierPromo}
             disabled={isSignature === true || isStartup === true}
              onChange={(e) =>  {
              const value = e.target.value;
              setStates({
                isTierPromo: e.target.value,
                isSignature: value ? false : isSignature,  // Disable Signature if Tier Promo is enabled
                isStartup: value ? false : isStartup,      // Disable Startup if Tier Promo is enabled
                isAdjustmentPromo: false , // Disable Adjustment Promo if Tier Promo is enabled
              });
            }
            }
            >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}
        {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && isTierPromo && (
          <Grid item xs={3}>
            <CssTextField
              id="Tier"
              label={t("Promotional Tier")}
              select
              fullWidth
              required={isTierPromo === true}   // ✅ required only for tier promo
              disabled={!isTierPromo}           // ✅ disabled unless tier promo
              value={tier}
              onChange={(e) => {
                setStates({ tier: e.target.value });
              }}
            >
              <MenuItem value="">
                {t("Select Promotional Tier")}
              </MenuItem>

              {tierArr.map((k, i) => (
                <MenuItem value={k.value} key={i}>
                  {k.label}
                </MenuItem>
              ))}
            </CssTextField>
          </Grid>
        )}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup  && !isSignature)&& <Grid item xs={3}>
          <CssTextField
            id={"Is Unlock"}
            label={t("Is Unlock")}
            select
            fullWidth
            type={"text"}
            required
            value={isUnlock}
            disabled={isTierPromo === true}
            onChange={(e) => {
            setStates({
            isUnlock: e.target.value      // Disable Startup if Signature is enabled
          })
          }}

          >
            
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}

        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isSignature && !isStartup && !isUnlock) && <Grid item xs={3}>
          <CssTextField
            id={"Tier Ratio Applicable"}
            label={t("Tier Ratio Applicable")}
            select
            fullWidth
            type={"text"}
            required
            value={tierRatioApplicable}
            onChange={(e) => {
              setStates({ tierRatioApplicable: e.target.value });
            }}
          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}
        { isLimited && <Grid item xs={3}>
          <CssTextField
            id={"Limit Type"}
            label={t("Limit Type")}
            select
            fullWidth
            type={"text"}
            required
            value={limitType}
            onChange={(e) => {
              setStates({ limitType: e.target.value });
            }}
          >
            {[
              { label: "Shipto", value: 'customer_account_number' },
              { label: "Billto", value: 'customer_billto_account_number' },
              { label: "Loyalty Id", value: 'loyalty_id' },

            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>}
        
       
        { isLimited && <Grid item xs={3}>
  <CssTextField
    label={t("Limit")}
    fullWidth
    type="number"
  onWheel={(e) => e.target.blur()}
    onKeyDown={(e) => {
    
      if (["e", "E", "+", "-", ".", "0"].includes(e.key)) {
        e.preventDefault();
      }
    }}
    className={classes.cssTextField}
    required
    value={limit}
    onChange={(e) => {
      const input = e.target.value;
      const value = input === "" ? "" : Number(input);

      // Accept only if value is a positive number (not 0)
      if (value === "" || value > 0) {
        setStates({ limit: value });
      }
    }}
  />
</Grid> }
{ state?.userInfo?.role_id == 10 && <Grid item xs={3}>
  <CssTextField
    label={t("Priority")}
    fullWidth
    type="number"
  onWheel={(e) => e.target.blur()}
    onKeyDown={(e) => {
    
      if (["e", "E", "+", "-", ".", "0"].includes(e.key)) {
        e.preventDefault();
      }
    }}
    className={classes.cssTextField}
    required
    value={priority}
    onChange={(e) => {
      const input = e.target.value;
      const value = input === "" ? "" : Number(input);

      // Accept only if value is a positive number (not 0)
      if (value === "" || value > 0) {
        setStates({ priority: value });
      }
    }}
  />
</Grid> }
        
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
            onClick={()=> {
              if(state?.userInfo?.editAction){
                setStates({ loading: true });
                handleCreateRule();
                return;
              }
              else{
                toast.error(state.userInfo?.editAccess)
                return;
              }
            }}
            disabled={loading}
          >
            {t('Submit')}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
